<template>
  <section
    :class="{ active: openIndex }"
    class="app-index"
  >
    <div
      class="app-index__btn"
      @click="openIndex = true"
    >
      <img src="../assets/hamburger.svg" alt="開啟" loading="lazy">
    </div>
    <div class="app-index__index">
      <div class="index-container">
        <ButtonClose
          class="index__close"
          @click="openIndex = false"
        />
        <div class="index">
          <ul>
            <li
              v-scroll-to="'#part-1'"
              :class="{ active: current === 1 }"
              @click="handleClickIndex(1)"
            >
              <span>生命晚期的不堪圖像</span>
            </li>
            <li
              v-scroll-to="'#part-2'"
              :class="{ active: current === 2 }"
              @click="handleClickIndex(2)"
            >
              <span>寧搭死亡快車</span>
            </li>
            <li
              v-scroll-to="'#part-3'"
              :class="{ active: current === 3 }"
              @click="handleClickIndex(3)"
            >
              <span>生命權跟死亡權的拉扯</span>
            </li>
            <li
              v-scroll-to="'#part-4'"
              :class="{ active: current === 4 }"
              @click="handleClickIndex(4)"
            >
              <span>「被安樂」就是被謀殺</span>
            </li>
            <li
              v-scroll-to="'#part-5'"
              :class="{ active: current === 5 }"
              @click="handleClickIndex(5)"
            >
              <span>獨老的現實</span>
            </li>
          </ul>
        </div>
        <div class="share">
          <p>分享到：</p>
          <a
            href="https://www.facebook.com/share.php?u=https://www.mirrormedia.mg/projects/they-all-request-for-euthanasia/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/facebook.svg" alt="facebook" loading="lazy">
          </a>
          <a
            href="https://line.me/R/msg/text/?https://www.mirrormedia.mg/projects/they-all-request-for-euthanasia/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/line.svg" alt="line" loading="lazy">
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import { throttle } from 'lodash'
import ButtonClose from './ButtonClose'

export default {
  name: 'AppIndex',
  components: {
    ButtonClose
  },
  data () {
    return {
      current: 0,
      gaScrollIndex: 0,
      openIndex: false
    }
  },
  mounted () {
    window.addEventListener('load', () => {
      this.detectCurrent(true)
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    openIndex (value) {
      value ? disableBodyScroll() : clearAllBodyScrollLocks()
    }
  },
  methods: {
    detectCurrent (isInit = false) {
      const items = [ ...document.querySelectorAll('.app-article > h2'), document.querySelector('.app-credit') ]
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight
      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect()
        if (rect.top <= viewportHeight) {
          this.current = index + 1
          if (isInit) {
            this.gaScrollIndex = index + 1
          }
          if (!isInit && this.current > this.gaScrollIndex) {
            this.gaScrollIndex = this.current
            window.gtag && window.gtag('event', 'scroll', {
              'event_category': 'projects',
              'event_label': this.gaScrollIndex === 6 ? '滑到 Credit' : `讀到第 ${this.gaScrollIndex} 段落標`
            })
          }
        }
      })
    },
    handleClick () {
      this.$emit('closeIndex')
    },
    handleClickIndex (index) {
      window.gtag && window.gtag('event', 'click', { 'event_category': 'projects', 'event_label': `段落標 ${index}` })
      this.openIndex = false
    },
    handleResize: throttle(function () {
      this.detectCurrent()
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth
      if (viewportWidth >= 1200) {
        this.openIndex = false
      }
    }, 300),
    handleScroll: throttle(function () {
      this.detectCurrent()
    }, 300)
  }
}
</script>
<style lang="scss" scoped>
.app-index {
  @media (min-width: 1200px) {
    position: -webkit-sticky;
    position: sticky;
  }
  &.active {
    .app-index__index {
      display: block;
    }
  }
  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 500;
    width: 44px;
    height: 44px;
    background-color: #191919;
    border-radius: 50%;
    cursor: pointer;
    @media (min-width: 1200px) {
      display: none;
    }
  }
  &__index {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 510;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    @media (min-width: 1200px) {
      display: inline-block;
      top: 50%;
      left: calc((100% - 634px) / 4);
      right: auto;
      bottom: auto;
      transform: translate(-50%, -50%);
      background-color: transparent;
      width: auto;
      height: auto;
    }
    .index-container {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      width: auto;
      height: 100%;
      padding: 0 12px;
      background-color: #fff;
      @media (min-width: 1200px) {
        position: static;
        padding: 0;
        background-color: transparent;
      }
    }
  }
}

.index {
  display: inline-block;
  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    @media (min-width: 1200px) {
      display: none;
    }
  }
  ul {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 190px;
    @media (min-width: 1200px) {
      width: 240px;
    }
    li {
      display: inline;
      font-size: 18px;
      font-weight: 900;
      font-family: source-han-serif-tc,serif;
      cursor: pointer;
      &.active {
        span {
          border-bottom: solid 2px #dec5a2;
        }
      }
      & + li {
        margin-top: 19px;
      }
    }
  }
}

.share {
  display: flex;
  align-items: center;
  margin-top: 48px;
  font-size: 15px;
  p + a {
    margin-left: 18px;
  }
  a + a {
    margin-left: 17px;
  }
}

</style>
